import React, { useEffect } from 'react';

//compoennts
import { checkValue } from 'src/components/common/helper';
import VideoPlayerComponent from 'src/components/common/modules/video-player/code-split/video-player-component';

//helpers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';

//types
import { HeroForegroundVideoProps } from '../../typings';
import { VideoPlayerProps } from 'src/components/common/module-util';

const HeroFgVideo: React.FC<HeroForegroundVideoProps> = (props) => {
  const { videoFileUrl, videoLink, videoPoster, width, height, siteid, campaignUrl, template } = props;

  let videoJsOptions = {};

  const { width: windowWidth } = useWindowDimensions();

  //set the bottom space if video is there
  const setBottomSpace = () => {
    const rootElm = document?.querySelector('.global-hero-section.with-fb-video') as HTMLElement;
    const videoParentElm = document?.querySelector('.hero-fg-video-component .c-player');
    if (rootElm && videoParentElm) {
      const videoParentElmHeight = videoParentElm?.clientHeight;
      rootElm.style.paddingBottom = `${
        videoParentElmHeight - (windowWidth <= 575 ? 100 : windowWidth <= 1300 ? 75 : 168)
      }px`;
    }
  };

  useEffect(() => {
    setBottomSpace();
  }, [windowWidth]);

  useEffect(() => {
    window.addEventListener('load', setBottomSpace);
    return () => {
      window.removeEventListener('load', setBottomSpace);
    };
  }, []);

  if (checkValue(videoFileUrl?.[0]?.url)) {
    videoJsOptions = {
      autoplay: false,
      controls: true,
      siteid,
      campaignUrl,
      template,
      sources: [
        {
          src: videoFileUrl?.[0]?.url,
          type: 'video/mp4',
        },
      ],
    };
  }

  if (checkValue(videoLink)) {
    videoJsOptions = {
      techOrder: ['youtube'],
      autoplay: false,
      controls: true,
      sources: [
        {
          src: videoLink,
          type: 'video/youtube',
        },
      ],
    };
  }

  const videoProps: VideoPlayerProps = {
    videoOptions: { ...videoJsOptions, poster: videoPoster?.[0]?.url },
    width: parseInt(width),
    height: parseInt(height),
  };

  return (
    <div
      className="hero-fg-video-component"
      style={
        checkValue(width, false)
          ? { maxWidth: width + 'px', transform: 'translate(-50%, 100%)', left: '50%', right: '0', width: '100%' }
          : { maxWidth: '76.375rem' }
      }
    >
      <VideoPlayerComponent
        {...videoProps}
        isHero={true}
        wrapperClass="hero-fg-video-container"
        isHeroPositionStore={true}
      />
    </div>
  );
};

export default HeroFgVideo;
